
import Vue from 'vue'
import XTable from 'vux/src/components/x-table/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

var TimeAuditPage = Vue.extend({})
Vue.component('timeAudit-page', TimeAuditPage)

export default {
  name: 'TimeAuditPage',
  components: {
    XTable, XButton
  },
  props: {
    idArr: Array
  },
  data () {
    return {
      baseUrl: this.$store.state.url,
      info: {},
      picArr: []
    }
  },
  mounted () {
    this.axios({
      url: this.baseUrl + '/wechat/workTime/getJson/' + this.idArr[0],
      method: 'get'
    }).then((response) => {
      this.info = response.data.data.info
    }).catch((response) => {
    })
},
  methods: {
    getImg () {
      // if(this.picArr.length>0){
      //   this.showImg ();
      // }else{
      this.$vux.loading.show({
        text: '加载中'
      })
      this.picArr = []
      this.axios({
        url: this.baseUrl + '/wechat/commonFile/screenPage?taskId=' + this.idArr[0] + '&flowId=' + this.idArr[1] + '&stepId=' + this.idArr[2],
        method: 'get'
      }).then((response) => {
        this.$vux.loading.hide()
        if (response.data.status == false) { // 返回失败
          this.showErr()
        } else { // 返回成功
          let urlArr = response.data.imageUrl.split(',')
          for (let i = 0; i < urlArr.length; i++) {
            if (urlArr[i] != '') {
              this.picArr.push(urlArr[i] + '?number=' + Math.random())
            }
          }
          if (this.picArr.length > 0) {
            this.showImg()
          } else {
            this.showErr()
          }
        }
      }).catch((response) => {
        this.$vux.loading.hide()
        this.showErr()
      })
    // }
    },
    showImg () {
      wx.previewImage({
        current: this.picArr[0],
        urls: this.picArr
      })
    },
    showErr () {
      this.$vux.alert.show({
        title: '暂无数据'
      })
      setTimeout(() => {
        this.$vux.alert.hide()
      }, 2000)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/detail/todo/business/timeAudit.vue